import update from "immutability-helper";
import type { AnyAction } from "redux";
import type { PrepSession } from "@theirstory/common/api_types/backend";

import { PREPSESSIONS_LOADED, PREPSESSIONS_STORIES_SET_PAGE_VIEW } from "../actions/types";

export interface PrepSessionsState {
  prepsessions: PrepSession[];
  paging: {
    size: 15;
    current: 1;
    count: 1;
    totalItems: 0;
  };
  loaded: false;
}

const initialState: PrepSessionsState = {
  prepsessions: [],
  paging: {
    size: 15,
    current: 1,
    count: 1,
    totalItems: 0,
  },
  loaded: false,
};

const prepSessionsReducer = (state = initialState, { type, payload }: AnyAction) => {
  switch (type) {
    case PREPSESSIONS_LOADED: {
      return update(state, { prepsessions: { $set: payload.prepsessions }, loaded: { $set: payload.loaded } });
    }
    case PREPSESSIONS_STORIES_SET_PAGE_VIEW: {
      // const { currentPage, pageSize } = payload;

      // this line will be removed after backend modification is completed
      return state;
      // return update(
      //   state,
      //   pageSize != null
      //     ? {
      //       prepSessions: {
      //           paging: {
      //             size: { $set: pageSize },
      //             current: { $set: currentPage != null ? currentPage : 1 },
      //           },
      //         },
      //       }
      //     : currentPage == null
      //     ? {}
      //     : { prepSessions: { paging: { current: { $set: currentPage } } } }
      // );
    }
    default:
      return state;
  }
};

export default prepSessionsReducer;
